import React, { Component } from 'react';
import TimesheetWeekSelect from './TimesheetWeekSelect'
import TimesheetSummary from './TimesheetSummary'
import { isAuthenticated } from '../../actions/authentication';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import styles from '../../styles/timesheet.module.css';
import { withCookies } from 'react-cookie';
import { RenewToken } from '../../utils/token';
import { ChatContext } from '@/ChatProvider';

class Timesheet extends Component {

    constructor(props) {
        super(props);

        this.state = {
            authenticated: false,
            startDate: null,
            endDate: null,
            saveDate: null,
            isActive: true
        }
    }

    componentDidMount() {
        this.handleTitle();

        this.handleToken();
    }

    async handleToken() {
        await RenewToken(this.props);

        isAuthenticated().then((result) => {
            this.setState({ authenticated: result });
            this.context.setIsAuthenticated(result);
        });
    }

    handleTitle() {
        this.props.onLoadTitle(i18next.t('menu:timesheet'));
    }

    onChangeDate = (startDate, endDate) => {
        this.setState(
            {
                startDate: startDate,
                endDate: endDate
            }
        );
    }

    onLoadComplete = (status) => {
        this.setState({ isActive: status });
    }

    onSaveForm = (date) => {
        this.setState({ saveDate: date });
    }

    render() {
        return (
            this.state.authenticated &&
            <LoadingOverlay
                className={styles.loadingOverlay}
                active={this.state.isActive}
                spinner={<BeatLoader />}
                text={i18next.t('expenseAccount:form.loading')}
            >
                <div className={styles.rootTimesheet}>
                    <TimesheetWeekSelect onChangeDate={this.onChangeDate} saveDate={this.state.saveDate} />
                    {this.state.startDate && <TimesheetSummary onSaveForm={this.onSaveForm} saveDate={this.state.saveDate} startDate={this.state.startDate} endDate={this.state.endDate} onLoadComplete={this.onLoadComplete} />}
                </div>
            </LoadingOverlay>
        );
    }
}

Timesheet.contextType = ChatContext;
export default withNamespaces(['menu', 'expenseAccount'], { wait: true })(withCookies(Timesheet));